const LAST_CONTEXT_PATH_KEY = 'epos2_last_context_path'

const isLegacyMposPath = (path = '') => String(path || '').startsWith('/mpos')

const getContextBaseUrl = (...paths) => {
  const isLegacyMposContext = paths.some((path) => isLegacyMposPath(path))

  return isLegacyMposContext
    ? process.env.VUE_APP_LEGACY_MPOS_URL
    : process.env.VUE_APP_EPOS_API_BASE
}

const persistLastContextPath = (path = '') => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return
  }

  const normalizedPath = String(path || '')

  if (!normalizedPath || normalizedPath === '/signin' || normalizedPath === '/logout') {
    return
  }

  window.sessionStorage.setItem(LAST_CONTEXT_PATH_KEY, normalizedPath)
}

const getLastContextPath = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return ''
  }

  return String(window.sessionStorage.getItem(LAST_CONTEXT_PATH_KEY) || '')
}

const getSessionExpiredRedirectBase = (...paths) => {
  const currentPath = typeof window === 'undefined'
    ? ''
    : String(window.location?.pathname || '')

  return getContextBaseUrl(...paths, currentPath, getLastContextPath())
}

export {
  getContextBaseUrl,
  getSessionExpiredRedirectBase,
  persistLastContextPath,
}